import { EnumProductTypes, Listing } from "src/types/listing";
import DemographicInfo from "./DemographicInfo";
import PropertyStats from "./PropertyStats";
import {
  DistressRate,
  formatPhoneNumber,
} from "../../common/PropertySummary";

export type PrintOneViewProps = {
  listing: Listing;
};
  
const PrintOneView = ({ listing }: PrintOneViewProps) => {
  const {
    title,
    distressedLevel,
  } = listing;

  const productType = listing.productType;

  return (
    <section className={"break-inside-avoid  align-top break-after-page"}>
      <div className=" flex flex-col gap-6 mt-4 break-inside-avoid avoidBreakInside  ">
        <div className="break-inside-avoid gap-1">
          <div className="flex flex-col group items-start w-full justify-between ">
            {distressedLevel ? <DistressRate rate={distressedLevel} /> : <></>}
            <div className="flex  group items-center w-full justify-between ">
              <p className=" leading-7 font-[500] text-[24px] text-gray-primary text-wrap	 cursor-pointer">
                <span className="hover:text-primary">{`${title}`}</span>
              </p>

              <p className=" leading-[12px] font-[500] text-[14px] text-placeholder text-wrap	 cursor-pointer">
                <span className="hover:text-primary">{`Date Processed: ${listing.formattedPublishDate}`}</span>
              </p>
            </div>
          </div>
          <PropertyStats listing={listing} variant="detailed" />
        </div>

        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 flex flex-col gap-6">
            {
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  my-1">
                    <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                      {[
                        EnumProductTypes.fsbo,
                        EnumProductTypes.preforeclosure,
                        EnumProductTypes.distressed,
                      ].includes(productType)
                        ? "Owner Information"
                        : "Tax Information"}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-[14px] ">
                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary  ">
                        <p className="font-semibold">Owner Name:</p>
                        {listing.ownerContactInfo.fullName ? (
                          <p className=" text-right">
                            {listing.ownerContactInfo.fullName}
                          </p>
                        ) : (
                          <p className="">--</p>
                        )}
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Phone Number:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerContactInfo.formattedPhone || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between text-gray-primary ] ">
                        <p className="font-semibold">Email: </p>
                        <p className=" text-right">
                          {listing.ownerContactInfo.email || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col text-[14px]  gap-2">
                      {productType !== EnumProductTypes.fsbo && (
                        <>
                          <div className="flex justify-between  text-gray-primary ] ">
                            <p className="font-semibold">Mailing Address:</p>

                            {listing.ownerContactInfo.address
                              ?.formattedAddress ? (
                              <p className=" text-right">
                                {
                                  listing.ownerContactInfo.address
                                    ?.formattedAddress
                                }
                              </p>
                            ) : (
                              <p className=" text-right">--</p>
                            )}
                          </div>

                          <div className="flex justify-between  text-gray-primary ] ">
                            <p className="font-semibold">Owner Address:</p>

                            {listing.ownerContactInfo.address
                              ?.formattedAddress ? (
                              <p className=" text-right">
                                {
                                  listing.ownerContactInfo.address
                                    ?.formattedAddress
                                }
                              </p>
                            ) : (
                              <p className=" text-right">--</p>
                            )}
                          </div>
                          <div className="flex justify-between  text-gray-primary ] ">
                            <p className="font-semibold">Tax ID: </p>
                            <p className=" text-right">
                              {" "}
                              {listing.taxId || "--"}
                            </p>
                          </div>
                        </>
                      )}

                      <div className="flex justify-between  text-gray-primary ">
                        <p className="font-semibold">Owner Occupied: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerOccupied ? "Yes" : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            }

            {[EnumProductTypes.expired, EnumProductTypes.oldexpired].includes(
              productType
            ) && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  my-1 ">
                    <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                      MLS Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-[14px]">
                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">MLS ID:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.mlsNumber || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Status: </p>
                        <p className=" text-right">
                          {listing.statusCode || " --"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Status Date: </p>
                        <p className=" text-right">
                          {listing.formattedStatusDate || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Agent:</p>
                        <p className=" text-right">
                          {listing.listAgent || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Phone: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.formattedListAgentPhone || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Company: </p>
                        <p className=" text-right">
                          {listing.listAgentCompany || "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.preforeclosure && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  my-1 ">
                    <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                      Mortgage Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 ">
                    <div className=" flex flex-col justify-between gap-2 text-[14px]">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Mortgage Holder:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.mortgageHolder || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Loan Amount: </p>
                        <p className=" text-right">
                          {listing.formattedLoanAmount}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">County Recorded: </p>
                        <p className=" text-right">
                          {listing.countyRecorded || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Attorney Name: </p>
                        <p className=" text-right">
                          {listing.attorneyName || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Mortgage Date:</p>
                        <p className=" text-right">
                          {listing.formattedMortgageDate || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Delinquent Amount: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.formattedDelinquentAmount || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Date Recorded: </p>
                        <p className=" text-right">
                          {listing.formattedDateRecorded || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Attorney Phone: </p>
                        <p className=" text-right">
                          {listing.formattedAttorneyPhone || "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.distressed && (
              <section>
                <div className="">
                  <div className="flex gap-4 h-7 items-center  my-1 ">
                    <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                      Mortgage Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 ">
                    <div className=" flex flex-col justify-between gap-2 text-[14px]">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Mortgage Holder:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.mortgageHolder || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Loan Amount: </p>
                        <p className=" text-right">
                          {listing.formattedLoanAmount}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Mortgage Date:</p>
                        <p className=" text-right">
                          {listing.formattedMortgageDate || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">County Recorded: </p>
                        <p className=" text-right">
                          {listing.countyRecorded || "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {productType === EnumProductTypes.ns && listing.demographics && (
              <DemographicInfo 
                demographics={listing.demographics} 
                variant="detailed" 
              />
            )}

            {productType === EnumProductTypes.preforeclosure && (
              <section className="text-[14px]">
                <div className="">
                  <div className="flex gap-4 h-7 items-center  my-1 ">
                    <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                      Auction Information{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-[14px]">
                    <div className=" flex flex-col justify-between gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Trustee Sale Number:</p>
                        <p className=" text-right">
                          {" "}
                          {listing.trusteeSaleNumber || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Auction Location: </p>
                        <p className=" text-right">
                          {listing.auctionLocation || " --"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Min Bid: </p>
                        <p className=" text-right">
                          {listing.formattedAuctionMinimumBid || "--"}
                        </p>
                      </div>
                    </div>

                    <div className=" flex flex-col  gap-2">
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Auction Date:</p>
                        <p className=" text-right">
                          {listing.formattedAuctionDate || "--"}
                        </p>
                      </div>
                      <div className="flex justify-between  text-gray-primary ] ">
                        <p className="font-semibold">Owner Occupied: </p>
                        <p className=" text-right">
                          {" "}
                          {listing.ownerOccupied ? "Yes" : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>
          <div className="col-span-1 ">
            <div className="flex gap-4 h-7 items-center  print:mb-0 ">
              <p className="whitespace-nowrap  font-bold leading-3 text-gray-primary">
                Phone Numbers{" "}
                <span className="font-[500] text-[12px] text-gray-secondary"></span>
              </p>{" "}
              <div className="h-[2px] w-full   bg-gray-300"></div>
            </div>
            <div className="flex flex-col gap-2 pt-1">
              {listing?.contacts && listing.contacts.length > 0 ? (
                listing.contacts.map((contact, index) => (
                  <div key={`contact-phone-${contact.id}`}>
                    <p className=" text-gray-primary ">{contact.fullName}</p>{" "}
                    <p
                      className={` ${
                        contact?.dnc ? "text-danger" : "text-gray-secondary"
                      }  `}
                    >{`${formatPhoneNumber(contact?.phone)} ${
                      contact?.dnc ? " DNC" : ""
                    }`}</p>{" "}
                  </div>
                ))
              ) : (
                <div>
                  <p className=" text-gray-primary ">No phone numbers found.</p>
                </div>
              )}
            </div>
          </div>
        </div>
        {[
          EnumProductTypes.fsbo,
          EnumProductTypes.expired,
          EnumProductTypes.oldexpired,
        ].includes(productType) && (
          <section className="">
            <div className="">
              <div className="flex gap-4 h-7 items-center  my-1 ">
                <p className="whitespace-nowrap text-[24px] font-bold leading-7 text-gray-primary">
                  {productType === EnumProductTypes.fsbo
                    ? "Ad Text"
                    : "Agent Remarks from MLS"}{" "}
                  <span className="font-[500] text-[12px] text-gray-secondary"></span>
                </p>
                <div className="h-[2px] w-full   bg-gray-300"></div>
              </div>
            </div>

            <p className=" text-gray-primary leading-[12px] print:text-[10px] print:leading-3 ">
              {productType === EnumProductTypes.fsbo
                ? listing.adText
                : listing.comments}
            </p>
          </section>
        )}

        <section>
          <div className="flex flex-col gap-6 text-[18px]">
            {[EnumProductTypes.expired, EnumProductTypes.oldexpired].includes(
              productType
            ) && (
              <div className="col-span-1 flex flex-col gap-2">
                <div className="">
                  <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                    <p className="whitespace-nowrap  font-bold  text-gray-primary">
                      Showing Instructions{" "}
                      <span className="font-[500] text-[12px] text-gray-secondary"></span>
                    </p>{" "}
                    <div className="h-[2px] w-full   bg-gray-300"></div>
                  </div>
                </div>
                <p className=" text-gray-primary text-[10px] ">
                  {listing.showingInstructions}
                </p>
              </div>
            )}
            <div className="col-span-1 flex flex-col gap-2">
              <div className="">
                <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                  <p className="whitespace-nowrap  font-bold  text-gray-primary">
                    Tags{" "}
                    <span className="font-[500] text-[12px] text-gray-secondary"></span>
                  </p>{" "}
                  <div className="h-[2px] w-full   bg-gray-300"></div>
                </div>
              </div>

              {listing?.tags?.length ? (
                <div className=" grid grid-cols-12  grid-flow-row gap-2">
                  {listing?.tags?.map((tag, index) => {
                    return (
                      <div
                        key={`tag-${tag}-${index}`}
                        className="flex items-center justify-between  px-4 gap-1 "
                      >
                        <p className=" text-gray-primary text-[10px] ">{tag}</p>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className=" text-placeholder  ">No tags found. </p>
              )}
            </div>
            <div className="col-span-2 flex flex-col gap-2">
              {" "}
              <div className="">
                <div className="flex gap-4 h-3 items-center  print:mb-0 ">
                  <p className="  font-bold  text-gray-primary">
                    Notes{" "}
                    <span className="font-[500] text-[12px] text-gray-secondary"></span>
                  </p>{" "}
                  <div className="h-[2px] w-full   bg-gray-300"></div>
                </div>
              </div>
              <div className=" inline-block">
                {listing?.notes?.length > 0 ? (
                  listing?.notes
                    ?.filter((note) => !!note)
                    .map((note, index) => {
                      return (
                        <p
                          key={`tag-${note.id}`}
                          className=" text-gray-primary text-[10px]  font-normal font-[lato] mr-2"
                        >
                          {`${index + 1})`} {note?.note}
                        </p>
                      );
                    })
                ) : (
                  <p className=" text-placeholder  ">No note </p>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default PrintOneView;
